import React, { PureComponent } from 'react'
import { Button, Table, Collapse, Alert } from 'react-bootstrap'
import { formatTimeString } from '../../utils/formatters'
import JsonModal from '../json_modal'
import ConfirmationModal from './tx_callbacks/confirmation_modal'
import { bindActionCreators } from 'redux'
import { resetTransactionCallback, transactionCallback } from '../../actions/transaction_callback'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import SpinnerCircle from '../spinner_circle'
import styles from '../css/spinner_circle_green.css'

class TxCallbacks extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false,
      modalContent: null,
      open: true,
      isCallbackModalOpen: false,
      callbackModalContent: null,
    }
  }

  openModalDialog = (e, content) => {
    e.preventDefault()
    this.setState({ isModalOpen: true, modalContent: content })
  }

  closeModalDialog = () => {
    this.setState({ isModalOpen: false, modalContent: null })
  }

  openCallbackModalDialog = (e, content) => {
    e.preventDefault()
    this.setState({ isCallbackModalOpen: true, callbackModalContent: content })
  }

  closeCallbackModalDialog = () => {
    const { resetTransactionCallback } = this.props
    this.setState({ isCallbackModalOpen: false, callbackModalContent: null })
    resetTransactionCallback()
  }

  render() {
    const { isModalOpen, modalContent, isCallbackModalOpen } = this.state
    const { transactionCallback, isFetching, results, txId, errorMessage } = this.props

    const chevronClass = this.state.open ? 'fa fa-chevron-down' : 'fa fa-chevron-right'
    const alertClass = this.props.data.length > 0 ? 'label label-info-data' : 'label label-info'
    const borderRadius = this.state.open ? '10px 10px 0 0' : '10px 10px 10px 10px'

    let content = 'Ready to test'
    if (isFetching) {
      content = <SpinnerCircle isActive styles={styles} />
    }
    if (errorMessage) {
      content = (
        <Alert variant='danger'>
          <strong>Error: </strong>
          {errorMessage}
        </Alert>
      )
    }
    if (results) {
      content = results.message
    }

    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <div
          onClick={() => this.setState({ open: !this.state.open })}
          className='ibox-title'
          style={{ borderRadius: borderRadius, cursor: 'pointer' }}
        >
          <i style={{ width: '10px' }} className={chevronClass} />
          <header>Transaction Callbacks</header>
          <span style={{ float: 'right' }} className={alertClass}>
            {this.props.data.length}
          </span>
        </div>
        <Collapse in={this.state.open}>
          <div>
            <div style={{ borderRadius: '0 0 10px 10px' }} className='ibox-content table-responsive'>
              {this.props.data && this.props.data.length ? (
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Created</th>
                      <th>Status</th>
                      <th>Response Raw</th>
                      <th>Status Code</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.data.map((entry, i) => (
                      <tr key={entry.id}>
                        <td>{formatTimeString(entry.created)}</td>
                        <td>{entry.state.toUpperCase()}</td>
                        <td>
                          {entry.response_raw && (
                            <Button
                              bsPrefix='btn btn-default'
                              style={{ cursor: 'pointer' }}
                              onClick={(e) => this.openModalDialog(e, entry.response_raw)}
                            >
                              View
                            </Button>
                          )}
                        </td>
                        <td>{entry.status_code}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <span>{'N/A'}</span>
              )}
              <JsonModal
                isModalDialogOpen={isModalOpen}
                content={modalContent}
                title='Raw Data'
                close={this.closeModalDialog}
              />
              <div className='text-center'>
                <Button onClick={(e) => this.openCallbackModalDialog(e, this.props.txId)} variant='info'>
                  <i className='fa fa-exchange' /> Test Callback
                </Button>
              </div>
              <ConfirmationModal
                txId={txId}
                results={results}
                errorMessage={errorMessage}
                handleCallback={transactionCallback}
                isFetching={isFetching}
                content={content}
                isModalDialogOpen={isCallbackModalOpen}
                title='Test Callback'
                close={this.closeCallbackModalDialog}
              />
            </div>
          </div>
        </Collapse>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  isFetching: state.transactionCallback.isFetching,
  results: state.transactionCallback.results,
  errorMessage: state.transactionCallback.errorMessage,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      transactionCallback,
      resetTransactionCallback,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TxCallbacks))
